enum VurbalizeEvents {
  INPUT_PROVIDED = "INPUT_PROVIDED",
  NEW_PAGE_NAVIGATION = "NEW_PAGE_NAVIGATION",
  USERS_FIRST_MESSAGE = "USERS_FIRST_MESSAGE",
  USER_SEND_MESSAGE = "USER_SEND_MESSAGE",
  TALK_TO_SALES_BUTTON_CLICK = "TALK_TO_SALES_BUTTON_CLICK",
  CALLBACK_REQUEST_EVENT = "CALLBACK_REQUEST_EVENT",
  TALK_TO_EXPERT_CLICKED = "TALK_TO_EXPERT_CLICKED",
  SUGGESTION_TEXT_CLICKED = "SUGGESTION_TEXT_CLICKED",
  CALENDLY_EVENT_FRONTEND = "CALENDLY_EVENT_FRONTEND",
  CALENDLY_UI_EVENT = "CALENDLY_UI_EVENT",
  IFRAME_BUTTON_CLICK_EVENT = "IFRAME_BUTTON_CLICK_EVENT",
  PERSONALIZED_DEMO = "PERSONALIZED_DEMO",
  DEMO_DATA_LOADED = "DEMO_DATA_LOADED",
  USER_DEMO_INPUT = "USER_DEMO_INPUT",
  DELTA_LOGS_MESSAGE_API = "DELTA_LOGS_MESSAGE_API",
  MEETING_CONNECT_REQUEST = "MEETING_CONNECT_REQUEST",
  REDIRECT_SUGGESTED = "REDIRECT_SUGGESTED",
  SOCKET_ERROR = "SOCKET.ERROR",
  SOCKET_RESPONSE_TIMEOUT = "SOCKET.RESPONSE.TIMEOUT",
  MEETING_REQUEST_EVENT = "MEETING_REQUEST_EVENT",
  FEEDBACK_FORM = "FEEDBACK_FORM",
  NETWORK_TIMEOUT_BACKEND = "NETWORK_TIMEOUT_BACKEND",
  USER_SEND_MESSAGE_ZIP_CODE = "USER_SEND_MESSAGE_ZIP_CODE",
  FEEDBACK_SUBMITTED = "FEEDBACK_SUBMITTED",
  CALENDLY_CLOSE_EVENT = "CALENDLY_CLOSE_EVENT",
  WIDGET_CHAT_ICON_CLICK = "WIDGET_CHAT_ICON_CLICK",
  CALLBACK_SUBMIT_EVENT = "CALLBACK_SUBMIT_EVENT",
  CALLBACK_UI_EVENT = "CALLBACK_UI_EVENT",
  REDIRECT_CLICKED = "REDIRECT_CLICKED",
  USER_FEEDBACK = "USER_FEEDBACK",
  USER_FEEDBACK_CLOSE = "USER_FEEDBACK_CLOSE",
  NUDGE_MESSAGE_TEXT = "NUDGE_MESSAGE_TEXT",
  WELCOME_MESSAGE_TEXT = "WELCOME_MESSAGE_TEXT",
  NUDGE_MESSAGE_TEXT_CLICKED = "NUDGE_MESSAGE_TEXT_CLICKED",
  CTA_ELEMENT_CLICKED = "CTA_ELEMENT_CLICKED",
  HUBSPOT_FORM_SUBMITTED = "HUBSPOT_FORM_SUBMITTED",
  HERO_PAGE_VISITED = "HERO_PAGE_VISITED",
  HUBSPOT_CALENDAR_OPEN = "HUBSPOT_CALENDAR_OPEN",
  HUBSPOT_MEETING_SCHEDULED = "HUBSPOT_MEETING_SCHEDULED",
  HUBSPOT_CALENDAR_CLOSE = "HUBSPOT_CALENDAR_CLOSE",
  MARKETO_EVENT = "MARKETO.EVENT",
  BROWSERTAB_CLOSE = "BROWSERTAB.CLOSE",
  INPUT_COLLECTION_TRIGGERED = "INPUT_COLLECTION_TRIGGERED",
  USER_RECEIVED_MESSAGE = "USER_RECEIVED_MESSAGE",
  NUDGE_CLOSED = "NUDGE_CLOSED",
  VURBALIZE_USER_SEND_MESSAGE = "VURBALIZE_USER_SEND_MESSAGE",
  WIDGET_CHAT_HEADER_CLOSE = 'WIDGET_CHAT_HEADER_CLOSE',
  DEMO_DATA_RECEIVE = 'DEMO_DATA_RECEIVE',
  GET_DATA_FOR_DEMO = 'GET_DATA_FOR_DEMO',
  USER_CLICK = 'USER_CLICK',
  USER_PRESENCE = 'USER_PRESENCE',
  LIVE_AGENT_PINGED_USER = 'LIVE_AGENT_PINGED_USER',
  USER_IS_ACTIVE = 'USER_IS_ACTIVE',
  CUSTOM_CALENDAR_OPENED = 'CUSTOM_CALENDAR_OPENED',
  CUSTOM_CALENDAR_CLOSED = 'CUSTOM_CALENDAR_CLOSED',
  CUSTOM_CALENDAR_EVENT_SCHEDULED = 'CUSTOM_CALENDAR_EVENT_SCHEDULED',
  CUSTOM_CALENDAR_UI_EVENT = 'CUSTOM_CALENDAR_UI_EVENT',
}

export default VurbalizeEvents;
